import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'react-modal';
import { useSwipeable } from 'react-swipeable';

import { Button } from '../../index';

import styles from './circle-modal.module.scss';

const cx = classnames.bind(styles);

function CircleModal({
  afterClose,
  afterOpen,
  appElementId,
  children,
  closeModal,
  contentLabel,
  ctaText,
  icon,
  open,
  requestClose,
  secondaryCtaText,
  secondaryCloseModal,
  swipeToClose,
}) {
  Modal.setAppElement(`#${appElementId}`);

  if (!closeModal && secondaryCloseModal) {
    closeModal = secondaryCloseModal;
  }

  if (open) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = null;
  }

  const modalCss = cx({
    'circle-modal': true,
    'has-cta': !!ctaText,
    'with-icon': !!icon,
  });

  const handlers = useSwipeable({
    onSwiped: () => {
      if (swipeToClose && typeof closeModal === 'function') {
        closeModal();
      }
    },
  });

  return (
    <Modal
      isOpen={open}
      onAfterOpen={afterOpen}
      onAfterClose={afterClose}
      onRequestClose={requestClose}
      contentLabel={contentLabel || 'Information Modal'}
      className={modalCss}
      overlayClassName={styles.overlay}
    >
      <div className={styles.content} {...handlers}>
        {icon && <img src={icon} alt="" className={styles.icon} />}
        {children}
        {ctaText && (
          <div className={styles.cta}>
            <Button onClick={closeModal} variant="text">
              {ctaText}
            </Button>
          </div>
        )}
      </div>
      {secondaryCtaText && (
        <div className={styles['secondary-cta']}>
          <Button onClick={secondaryCloseModal} variant="text">
            {secondaryCtaText}
          </Button>
        </div>
      )}
    </Modal>
  );
}

CircleModal.propTypes = {
  afterClose: PropTypes.func,
  afterOpen: PropTypes.func,
  appElementId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  closeModal: PropTypes.func,
  contentLabel: PropTypes.string,
  ctaText: PropTypes.string,
  icon: PropTypes.string,
  open: PropTypes.bool,
  requestClose: PropTypes.func,
  secondaryCtaText: PropTypes.string,
  secondaryCloseModal: PropTypes.func,
  swipeToClose: PropTypes.bool,
};

CircleModal.defaultProps = {
  appElementId: 'root',
};

export default CircleModal;
